module.exports = __webpack_public_path__ + "img/ClickForSound_21.2598bc2e.png";